import { IFramePostMessages } from "../../../../models/modules/lotteryplatform-client.models";
var image = "".concat(__CDN_IMAGES__, "/devices/iPhone.png");
var imageIPad = "".concat(__CDN_IMAGES__, "/devices/iPad.png");
var imageMacBook = "".concat(__CDN_IMAGES__, "/devices/macbook.png");
export function bioMp(el, options) {
    // Options
    var options = options || {}, url = setOption(options.url, ''), view = setOption(options.view, 'front');
    function setOption(option, _default) {
        return (typeof option === 'undefined') ? _default : option;
    }
    function create() {
        // Set view dimensions
        var selView = options.type == ScreenType.IPhone ? {
            image: image,
            width: 428,
            height: 889,
            frameTop: 109,
            frameLeft: 26.5,
            frameWidth: 375,
            frameHeight: 669,
            scale: 0.75
        } : options.type == ScreenType.IPad ? {
            image: imageIPad,
            width: 897,
            height: 1230,
            frameTop: 125,
            frameLeft: 50,
            frameWidth: 802,
            frameHeight: 979,
            scale: 0.6
        } : options.type == ScreenType.Mac ? {
            image: imageMacBook,
            width: 1920,
            height: 1080,
            frameTop: 66,
            frameLeft: 225.5,
            frameWidth: 1466,
            frameHeight: 898,
            scale: 0.5
        } : {
            image: image,
            width: 428,
            height: 889,
            frameTop: 109,
            frameLeft: 26.5,
            frameWidth: 375,
            frameHeight: 669,
            scale: 0.75
        };
        // Set scrollbar CSS		
        var css = document.createTextNode('.bio-mp-screen::-webkit-scrollbar {width: 6px; height: 6px;}' +
            '.bio-mp-screen::-webkit-scrollbar-track {background: none; -webkit-border-radius: 10px; border-radius: 10px;}' +
            '.bio-mp-screen::-webkit-scrollbar-thumb {-webkit-border-radius: 10px; border-radius: 10px; background: #777;}' +
            '.bio-mp-screen::-webkit-scrollbar-thumb:window-inactive {background: #777;}');
        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(css);
        // Add phone div
        var phone = document.createElement('div');
        el.appendChild(phone);
        // Add phone image
        var phoneImage = document.createElement('img');
        phoneImage.src = selView.image;
        phone.appendChild(phoneImage);
        var wrapper = document.createElement('div');
        phone.appendChild(wrapper);
        // Add iframe
        var iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.style.cssText = "width: 100%; height: 100%; border: 0;";
        iframe.className = 'bio-mp-screen';
        wrapper.appendChild(iframe);
        window.addEventListener('message', function (x) {
            if (x && x.data && x.data.event == IFramePostMessages.onIFrameHeightChange) {
                $(iframe).height(x.data.detail.height);
                //Fixes issue when changing from 1 page to another so that after reload the page start from the top
                if (x.data.detail.scrollTop) {
                    $(wrapper).animate({ scrollTop: 0 }, 0);
                }
            }
        }, true);
        // Add CSS
        var wrapCss = 'width: ' + selView.width * selView.scale + 'px; height: ' + selView.height * selView.scale + 'px; overflow: hidden; transform-origin: 0 0 0;';
        var phoneCss = 'position: relative; top: 0px; left: 0px; width: ' + selView.width + 'px; height: ' + selView.height + 'px; background: none; -webkit-transform-origin: 0 0 0; -moz-transform-origin: 0 0 0; -ms-transform-origin: 0 0 0; -o-transform-origin: 0 0 0; transform-origin: 0 0 0; -webkit-transform: scale(' + selView.scale + '); -moz-transform: scale(' + selView.scale + '); -ms-transform: scale(' + selView.scale + '); -o-transform: scale(' + selView.scale + '); transform: scale(' + selView.scale + ');';
        var phoneImageCss = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;';
        var screenCss = 'position: absolute; top: ' + selView.frameTop + 'px; left: ' + selView.frameLeft + 'px; width: ' + selView.frameWidth + 'px; height: ' + selView.frameHeight + 'px; overflow: hidden auto;';
        el.style.cssText += wrapCss;
        phone.style.cssText = phoneCss;
        phoneImage.style.cssText = phoneImageCss;
        wrapper.style.cssText = screenCss;
        // Add scrollbar CSS above the wrap
        el.parentNode.insertBefore(style, el);
    }
    // Init
    create();
}
export var ScreenType;
(function (ScreenType) {
    ScreenType[ScreenType["IPhone"] = 1] = "IPhone";
    ScreenType[ScreenType["IPad"] = 2] = "IPad";
    ScreenType[ScreenType["Mac"] = 3] = "Mac";
})(ScreenType || (ScreenType = {}));
